import { render, staticRenderFns } from "./modalAgendamentoConcluido.vue?vue&type=template&id=52df12b3&scoped=true"
import script from "./modalAgendamentoConcluido.vue?vue&type=script&lang=js"
export * from "./modalAgendamentoConcluido.vue?vue&type=script&lang=js"
import style0 from "./modalAgendamentoConcluido.vue?vue&type=style&index=0&id=52df12b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df12b3",
  null
  
)

export default component.exports